import { observable, action, computed, makeObservable } from 'mobx';

import { ServiceGroupData, ServiceGroupQuery } from 'chaika-frontend-types/frontend-cms';

import { ServiceGroupList } from './ServiceGroupList';
import { SearchList } from '@store/abstract/SearchList';

export class ServiceGroupStore {
    public static Name = 'serviceGroupStore' as const;

    @observable public serviceGroupList: ServiceGroupList = new ServiceGroupList();

    @observable
    public searchList: SearchList<ServiceGroupData, ServiceGroupData, ServiceGroupQuery> = new SearchList(
        ServiceGroupList,
    );

    constructor() {
        makeObservable(this);
    }

    @computed
    public get searchParams(): ServiceGroupQuery {
        return {
            ...this.searchList.searchParams,
        };
    }

    @action
    public reset() {
        this.serviceGroupList.reset();
        this.resetQuery();
    }

    @action
    public resetQuery() {
        this.searchList.reset();
    }

    public getFilteredListWithCount(): { services: ServiceGroupData[]; count: number } {
        const list = this.searchList.searchParamsSet ? this.searchList : this.serviceGroupList;
        const filterParams = this.serviceGroupList.getFilterParams();

        return {
            services: list.getFilteredValues(filterParams),
            count: list.count,
        };
    }
}

export const serviceGroupStore = new ServiceGroupStore();
